import type { GamblingTip } from '@/components/success-gambling/context';

export const KEY_TO_GET_COMPANIES = ['bettingCompanies', 'furtherBettingCompanies'];

export const ANSWER_SEPARATOR = ', ';

export const MAIL_SUBJECT = 'Datenschutzauskunft nach Art. 15 DSGVO für {fullName}';

export const MAIL_BODY = `
  Sehr geehrte Damen und Herren,

  hiermit mache ich von meinem Recht gemäß Artikel 15 der Datenschutz-Grundverordnung (DSGVO) Gebrauch und ersuche um eine umfassende Auskunft über die von Ihnen über mich gespeicherten personenbezogenen Daten.

  Ich bitte um detaillierte Informationen zu:

  • Den konkret gespeicherten personenbezogenen Daten (Name, Adresse, Kontodaten etc.)
  • Den Zwecken der Datenverarbeitung
  • Der Weitergabe meiner Daten an Dritte und gegebenenfalls deren Identität
  • Sämtlichen gespeicherten Transaktions- und Spieldaten (Spielhistorie, Einzahlungen, Auszahlungen)
  • Höhe der gesetzten Limits und Änderungsdaten
  • Der gesamten persönlichen Kommunikation zwischen mir und Ihrem Unternehmen
  • Sonstigen über mich gespeicherten Informationen

  Zusätzlich ersuche ich um eine vollständige Kopie der über mich gespeicherten Daten.
  Gemäß Artikel 12 Absatz 3 DSGVO ist diese Auskunft innerhalb eines Monats zu erteilen.

  Mit freundlichen Grüßen

  {fullName}
`;

export const FIX_TIPS: GamblingTip[] = [
  {
    type: 'separator',
    twoLines: false,
    title: '',
    text: '',
  },
  {
    type: 'copy',
    twoLines: true,
    title: 'Betreff',
    text: 'Datenschutzauskunft nach Art. 15 DSGVO für {fullName}',
  },
  {
    type: 'separator',
    twoLines: false,
    title: '',
    text: '',
  },
  {
    type: 'copy',
    twoLines: true,
    title: 'Textvorlage',
    text: MAIL_BODY,
  },
];

export const EMAILS: Record<string, string> = {
  '888sport.de': 'kontakt@888.de',
  AdmiralBet: 'hilfe@admiralbet.de',
  Bet3000: 'support@bet3000.com',
  bet365: 'data.protection@bet365.com',
  Betano: 'dpo-office@betano.de',
  Betclic: 'support@betclic.com',
  Betfair: 'dataprotection@paddypowerbetfair.com',
  Betsafe: 'dataprivacy@betssongroup.com',
  Betsson: 'dataprivacy@betssongroup.com',
  Betvictor: 'dataprotection@betvictor.com',
  betway: 'dataprotectionofficer@betway.de',
  'bwin.com': 'privacy@bwin.com',
  Comeon: 'dpo@comeonwetten.de',
  Gamebookers: 'agonzalez@gvcgroup.com',
  'Interwetten Sportwetten': 'dataprotection@interwetten.com',
  'Ladbrokes.de': 'dataprotectionofficer@entaingroup.com',
  mobilebet: 'dpo@mobilebet.de',
  'Neo.bet': 'dataprotection@neo.bet',
  Nordicbet: 'support-en@nordicbet.com',
  premium: 'dataprotectionofficer@entaingroup.com',
  Sportingbet: 'privacy@sportingbet.de',
  Sunmaker: 'dpo@sunmaker.de',
  Sunnyplayer: 'support@sunnyplayer.com',
  Tipico: 'dpo@tipico.com',
  'Tipico Games': 'dpo@tipico.com',
  Tipwin: 'support@tipwin.com',
  Unibet: 'dpo@kindredgroup.com',
  Xtip: 'privacy@merkur-sports.de',
};
